var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.55 8.33917C14.164 6.22008 12.136 5 10 5C8.932 5 7.894 5.30356 6.946 5.86982C5.998 6.44191 5.146 7.27671 4.45 8.33917C3.85 9.25569 3.85 10.7443 4.45 11.6608C5.836 13.7858 7.864 15 10 15C11.068 15 12.106 14.6964 13.054 14.1302C14.002 13.5581 14.854 12.7233 15.55 11.6608C16.15 10.7501 16.15 9.25569 15.55 8.33917ZM10 12.3614C8.656 12.3614 7.576 11.3047 7.576 10.0029C7.576 8.70111 8.656 7.64448 10 7.64448C11.344 7.64448 12.424 8.70111 12.424 10.0029C12.424 11.3047 11.344 12.3614 10 12.3614Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9965 8C8.89667 8 8 8.89667 8 10.0035C8 11.1033 8.89667 12 9.9965 12C11.0963 12 12 11.1033 12 10.0035C12 8.90368 11.0963 8 9.9965 8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/open-eye.60cf834717e710e10fd61125385b3d31.svg";
export { ForwardRef as ReactComponent };